import {Action} from 'redux'
import {IPGServiceModel} from '../Model/IPGServiceModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialIPGServiceState: IIPGServiceState = {
  data: {
    ipgService: [],
    meta: [],
  },
  sortIPGServiceData: [],
  ipgServiceList: {ipgService: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IIPGServiceState {
  data?: {
    ipgService?: IPGServiceModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortIPGServiceData?: IIPGServiceState[]
  ipgServiceList?: {ipgService: IPGServiceModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IIPGServiceState = initialIPGServiceState,
  action: ActionWithPayload<IIPGServiceState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_IPG_SERVICE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_IPG_SERVICE_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        ipgServiceList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_IPG_SERVICE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET IPGService DATA
    case actionTypes.GET_IPG_SERVICE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_IPG_SERVICE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_IPG_SERVICE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add IPGService
    case actionTypes.ADD_IPG_SERVICE_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_IPG_SERVICE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_IPG_SERVICE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_SEARCH_TAG: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update IPGService
    case actionTypes.UPDATE_IPG_SERVICE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_IPG_SERVICE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_IPG_SERVICE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_IPG_SERVICE_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_IPG_SERVICE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_IPG_SERVICE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_IPG_SERVICE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_IPG_SERVICE_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_IPG_SERVICE_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_IPG_SERVICE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_IPG_SERVICE_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_IPG_SERVICE_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_IPG_SERVICE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_IPG_SERVICE_SUCCESS: {
      const changedData: any = action.payload?.data?.ipgService
      let newData = state?.data?.ipgService?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, ipgService: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_IPG_SERVICE_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_IPG_SERVICE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_IPG_SERVICE_SUCCESS: {
      const changedData: any = action.payload?.data?.ipgService
      let newData = state?.data?.ipgService?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, ipgService: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_IPG_SERVICE_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_IPG_SERVICE_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_IPG_SERVICE_SUCCESS: {
      return {
        ...state,
        sortIPGServiceData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_IPG_SERVICE_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_IPG_SERVICE_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortIPGServiceData: [],
      }
    }

    default:
      return state
  }
}
